import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { tutorApiClient } from '../../tutorApiClient';
import { PassProviderDetail } from '../../models/Pass';
import PassInstanceDetailsView from '../../components/passes/PassInstanceDetailsView';

/** Tutor-scoped pass instance detail from booking `passDetailUrl` (`/tutor/passes/{passId}`). */
export default function TutorPassInstanceDetailsPage() {
  const { passId } = useParams<{ passId: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pass, setPass] = useState<PassProviderDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPass = useCallback(async () => {
    if (!passId) return;
    try {
      setLoading(true);
      setError(null);
      const data = await tutorApiClient.getPassInstance(passId);
      setPass(data);
    } catch (err) {
      console.error(`Error fetching tutor pass instance ${passId}:`, err);
      setError(t('passInstances.details.fetchError', 'Failed to load this pass'));
    } finally {
      setLoading(false);
    }
  }, [passId, t]);

  useEffect(() => {
    fetchPass();
  }, [fetchPass]);

  return (
    <PassInstanceDetailsView
      audience="tutor"
      pass={pass}
      loading={loading}
      error={error}
      backLabel={t('common.back', 'Back')}
      onBack={() => navigate(-1)}
    />
  );
}
